/* eslint-disable react/no-did-update-set-state */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useContext } from 'react'
import { node } from 'prop-types'

import CheckoutContext from 'contexts/Checkout'

const Context = React.createContext({})

const PromotionProvider = ({ children }) => {
  const { priceBreakdown } = useContext(CheckoutContext)
  const [discountState, setDiscountState] = useState(null)
  const [creditState, setCreditState] = useState(null)

  useEffect(() => {
    if (priceBreakdown?.regular) {
      if (priceBreakdown.regular.discount && priceBreakdown.regular.discount.code) {
        setDiscountState('applied')
      } else {
        setDiscountState(null)
      }

      if (priceBreakdown.regular.credit) {
        setCreditState('applied')
      } else {
        setCreditState(null)
      }
    }
  }, [priceBreakdown?.regular])

  const value = {
    discountState,
    setDiscountState,
    creditState,
    setCreditState,
    discount: priceBreakdown?.regular.discount,
    credit: priceBreakdown?.regular.credit
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

PromotionProvider.propTypes = {
  children: node
}

const { Consumer } = Context
export { Consumer as PromotionConsumer, PromotionProvider }

export default Context
